export type DeprecatedCustomerAnalyzeRoutePageId =
  | "analytics" // the suffix is not forgotten; this route was deprecated incorrectly and the PageId still exists.
  | "analytics-2"
  | "cloud-diagrams-2"
  | "cloud-diagrams:onboarding-2"
  | "analytics:reports-2"
  | "analytics:reports:create-2"
  | "analytics:reports:details-2"
  | "analytics:reports:labels-2"
  | "analytics:report-templates-2";

export type DeprecatedCustomerAnalyzeRouteConfig = {
  pageId: DeprecatedCustomerAnalyzeRoutePageId;
  route: string;
};

export const deprecatedCustomerAnalyzeRoutes: DeprecatedCustomerAnalyzeRouteConfig[] = [
  {
    pageId: "cloud-diagrams-2",
    route: "/cloud-diagrams",
  },
  {
    pageId: "cloud-diagrams:onboarding-2",
    route: "/cloud-diagrams/onboarding",
  },
  {
    pageId: "analytics",
    route: "/analytics",
  },
  {
    pageId: "analytics:reports-2",
    route: "/analytics/reports",
  },
  {
    pageId: "analytics:reports:create-2",
    route: "/analytics/reports/create",
  },
  {
    pageId: "analytics:reports:details-2",
    route: "/analytics/reports/:reportId",
  },
  {
    pageId: "analytics:reports:labels-2",
    route: "/analytics/reports/labels",
  },
  {
    pageId: "analytics:report-templates-2",
    route: "/analytics/report-templates",
  },
];
